import axios from "axios";
import { API_BASE_URL } from "./api.config";

// This client belongs to the public onboarding route. It deliberately has no
// interceptor and never reads or writes the dashboard's shared session.
const onboardingApi = axios.create({ baseURL: API_BASE_URL });

const responseBody = (response) => response.data;

export const onboardingService = {
  login: (email, password) =>
    onboardingApi
      .post("/login", { user_name: email, password })
      .then(responseBody),

  getMyProfile: (token) =>
    onboardingApi
      .get("/users/myUser", { headers: { sessiontoken: token } })
      .then(responseBody),

  changePassword: (token, password) =>
    onboardingApi.patch(
      "/users/myUser",
      { password },
      { headers: { sessiontoken: token } }
    ),

  getSurveyStatus: (token) =>
    onboardingApi
      .get("/auth/check-survey-status", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(responseBody),

  getSurveyQuestions: (token, surveyId) =>
    onboardingApi
      .get(`/auth/get-survey-questions/${encodeURIComponent(surveyId)}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(responseBody),

  saveSurvey: (token, payload) =>
    onboardingApi
      .post("/auth/save-survey", payload, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(responseBody),
};

export default onboardingService;
